import {NavigationPathKey, TranslationKey} from '@enums'
import accessoriesCardImage from '@images/accessories-card.jpg'
import bulkUploadCardImage from '@images/bulk-upload-card.jpg'
import productsCardImage from '@images/products-card.jpg'
import {Stack, useMediaQuery, useTheme} from '@mui/material'
import {pageLinksAtom} from '@state'

import {useEffect} from 'react'

import {TitleLink} from 'common/types'
import {useSetAtom} from 'jotai'
import {useTranslation} from 'react-i18next'

import {ComposedComponents} from '@components'

/**
 * Products and Accessories Dashboard page with navigation cards
 */
export function ProductAndAccessoriesDashboardPage() {
  const {t} = useTranslation()

  const theme = useTheme()
  const setTitleLinks = useSetAtom(pageLinksAtom)
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'))

  const titleLinks: TitleLink[] = [
    {
      title: t(TranslationKey['Admin panel']),
      link: NavigationPathKey.ADMIN_PANEL,
    },
    {
      title: t(TranslationKey['Products and accessories']),
    },
  ]

  useEffect(() => {
    setTitleLinks(titleLinks)
  }, [titleLinks])

  const navigationCardItems: ComposedComponents.CardItem[] = [
    {
      title: t(TranslationKey.Products),
      key: NavigationPathKey.PRODUCT_SEARCH,
      image: productsCardImage,
    },
    {
      title: t(TranslationKey.Accessories),
      key: NavigationPathKey.ACCESSORY_SEARCH,
      image: accessoriesCardImage,
    },
    {
      title: t(TranslationKey['Bulk upload']),
      key: NavigationPathKey.PRODUCT_BULK_CREATION,
      image: bulkUploadCardImage,
    },
  ]

  return (
    <Stack gap={5}>
      <ComposedComponents.NavigationCards itemsInRow={isDownLg ? 1 : 3} items={navigationCardItems} />
    </Stack>
  )
}
